// Мост между слоем `Request` (на fetch) из tg-mini и общими Vuex-экшенами
// coin-service / auth-service из @emcd-shared.
import { Request } from "@/api/request";
import { API } from "@/api/constants";
import store from "@/store";

const makeClient = (base) => ({
  async get(path) {
    const res = await Request.get(`${base}${path}`);
    return res?.ok ? res.data : undefined;
  },
  async post(path, body) {
    const res = await Request.post(`${base}${path}`, body);
    return res?.ok ? res.data : undefined;
  },
});

// TODO: убрать regex и обновить env после рефактора
// `loadProfile` сам добавляет `/v1` (`/v1/dashboard`) — убираем `/v1` в VITE_API_EMCD_API
const EMCD_ROOT = (API.EMCD_API || "").replace(/\/v1\/?$/, "");

export const coinServiceApi = {
  endpointApi: makeClient(API.ENDPOINT),
  ratesApi: makeClient(API.RATE),
  emcdApi: makeClient(EMCD_ROOT),
};

let inFlight = null;
// Монотонная «эпоха» загрузки: растёт на каждом старте. resetSession (auth.js)
// сверяет её, чтобы догоняющий сброс стора не стёр свежую сессию при быстром relogin.
let loadEpoch = 0;

export function currentLoadEpoch() {
  return loadEpoch;
}

export function loadCoinServiceBalance() {
  if (inFlight) return inFlight;

  loadEpoch++;
  const p = Promise.allSettled([
    store.dispatch("auth/loadProfile", coinServiceApi.emcdApi),
    store.dispatch("coinService/GET_COINS", coinServiceApi.endpointApi),
    store.dispatch("coinService/GET_BALANCES", coinServiceApi.endpointApi),
    store.dispatch("coinService/GET_RATE_PAIRS", coinServiceApi.ratesApi),
  ]);
  inFlight = p;
  // Обнуляем, только если это всё ещё наш промис — иначе гонка с takeBalanceLoadInFlight()
  p.finally(() => {
    if (inFlight === p) inFlight = null;
  });

  return p;
}

// Точечная перезагрузка балансов после операций (депозит/вывод/обмен).
export function reloadBalances() {
  return store.dispatch("coinService/GET_BALANCES", coinServiceApi.endpointApi);
}

// Загрузка secure-настроек (2FA), /profile/2fa_setup.
// loadSecure бросает при ошибке — гасим на стороне вызова (.catch).
export function loadSecure() {
  return store.dispatch("auth/loadSecure", coinServiceApi.endpointApi);
}

// Перезагрузка профиля
export function loadProfile() {
  return store.dispatch("auth/loadProfile", coinServiceApi.emcdApi);
}

// Язык пользователя с сервера
export function loadLanguage() {
  return store.dispatch("auth/fetchGetLanguage", coinServiceApi.endpointApi);
}

// Обнуляет текущий in-flight промис загрузки (или null) при логауте
export function takeBalanceLoadInFlight() {
  const p = inFlight;
  inFlight = null;
  return p;
}
